module.exports = __webpack_public_path__ + "static/media/Signupbg.cfb6144e.png";